import { render } from "./JSONFormatter.vue?vue&type=template&id=912da282&scoped=true&ts=true"
import script from "./JSONFormatter.vue?vue&type=script&lang=ts"
export * from "./JSONFormatter.vue?vue&type=script&lang=ts"

import "./JSONFormatter.vue?vue&type=style&index=0&id=912da282&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-912da282"]])

export default __exports__